export default [
  {
    icon: <i className='fa fa-home'/>,
    key: '/home',
    label: '首页',
  },
]
